import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ConvertService } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT, SKILL_OBJECT } from 'src/app/dummy/status';
import { IActivity } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddHangmanComponent } from './add-hangman/add-hangman.component';

@Component({
  selector: 'app-hangman',
  templateUrl: './hangman.component.html',
  styleUrls: ['./hangman.component.scss']
})
export class HangmanComponent implements OnInit {
  tabs = TABS.HANGMAN;
  TITLE = "Modules"
  ITEM: any;
  ITEM_KEY: any;
  MODULE_KEY: any;
  MODULE: any;

  form: FormGroup;
  name: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'vocabulary';
  SKILL_NAME = 'Vocabulary';
  ACTIVITY_TYPE = 'hangman'
  ACTIVITY_LIST: any[] = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }

  goBack() {
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  // goBackToActivityType() {
  //   this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  // }

  // newActivity() {
  //   this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/draft`])
  // }

  // onActivity(activity) {
  //   this.router.navigate([`/modules/activity-type/${activity.activityTypeKey}/${activity.skillKey}/${activity.moduleKey}/${activity.key}`])
  // }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
      instruction: [null],
      defaultInstruction: [true],
    })

    this.route.params.subscribe(async params => {
      const { selectedCompanyKey } = this.auth;
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.HANGMAN.filter(m => m.key === this.SKILL).map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.VOCABULARY.key ? id : 'draft'}`, label: m.label, key: m.key }))
      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      // this.resource.fetchActivityByModule(this.MODULE_KEY, this.ACTIVITY_TYPE, selectedCompanyKey, docs => {
      //   this.ACTIVITY_LIST = docs;
      // })
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.goBack()
            return;
          }
          const { name, instruction, defaultInstruction, answerText } = doc;
          this.form.patchValue({ name, instruction, defaultInstruction, answerText })
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ name: null, instruction: null, defaultInstruction: true, answerText: null })
      }
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    const {fetchActivityRef}=this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
  }

  // create() {
  //   // this.router.navigate([`/modules/activity-types/${this.MODULE_KEY}`])
  // }

  async onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { name, instruction, defaultInstruction } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      const activity: IActivity = {
        key: key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : this.ds.serverTimestamp(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: this.ds.serverTimestamp(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        hasSubActivity: true,
        questions: this.ITEM ? this.ITEM.questions : [],
        //module
        skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
        skillRef: this.ds.skillRef().doc(this.SKILL).ref,
        skillName: this.SKILL_NAME,
        activityTypeKey: this.ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
        activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
        moduleKey: this.MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
        if (success) {
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.location.back()
          }
          else {
            this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
          }
          this.form.enable();
        }
      })

    }
  }

  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Dictation' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        this.store.delete(question, (success, res) => {
          this.snackBar.open("Dictation has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
          this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/draft`])
        })
      }
    })
  }


  addNewExercise(item: any) {
    let dialogRef = this.dialog.open(AddHangmanComponent, {
      data: {
        EXERCISE: item || null,
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }



}
